import queryString from 'query-string';

export const getParametrosURL = () => {
    if (typeof window !== "undefined")
        return queryString.parse(window.location.search);

    return null;
}

/**
 * Remove acentuação e caracteres especiais de uma string.
 *
 * Esta função realiza duas operações principais:
 * 1. Remove acentos e cedilhas, convertendo caracteres como "ç" para "c", "ã" para "a", etc.
 * 2. Remove todos os caracteres especiais, mantendo apenas letras (a-z, A-Z), números (0-9) e espaços.
 *
 * Útil para normalizar strings antes de comparações, buscas ou geração de slugs/URLs.
 *
 * @param {string} texto - A string que será normalizada.
 * @returns {string} - A string sem acentuação e caracteres especiais.
 *
 * @example
 * sanitizeText("Olá, João Santos! Você viu o coração? çÇãÃ.");
 * // Retorno: "Ola Joao Voce viu o coracao cCaA"
 */
export function sanitizeText(texto) {
    if (!texto || texto.length == 0) return ''
    let textoNormalizado = texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

    textoNormalizado = textoNormalizado.replace(/[^a-zA-Z0-9,]/g, " ")

    textoNormalizado = textoNormalizado.replace(/\s+/g, " ").trim()
    return textoNormalizado
}